/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import quotes from "./quotes/slice";
import users from "./users/slice";
import customers from "./customers/slice";
import guiOptions from "./quote-options/slice";
import { configureStore, ConfigureStoreOptions, createReducer } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

// Global matcher to log runtime errors in actions & reducers.
const errorsLogger = createReducer({}, (builder) => {
  builder.addMatcher(
    () => true,
    (state, action) => {
      if (action.error) {
        console.error(action.error.stack);
      }
    }
  );
});

// Create store function.
const createStore = (options?: ConfigureStoreOptions["preloadedState"] | undefined) =>
  configureStore({
    reducer: {
      errorsLogger,
      quotes,
      users,
      customers,
      guiOptions,
    },
    ...options,
  });

// Store instance.
const store = createStore();
export default store;

// Store types.
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

// Global reference.
// window.redux = store;
